export default __webpack_public_path__ + "static/1873-b70ed9c7d24a902be1b025d1f75e6501.gif";